// extracted by mini-css-extract-plugin
module.exports = {"fixWidth":"EffectiveSplit_fixWidth___RTZ0"};